import { useMemo } from 'react';
import { useTranslation } from '@ibk/shared-translation';
import { useGetVoucherContractSummaryQuery } from '../services/benefitApi';
export function useVoucherContractSummary({ voucherContractId, }) {
    const { t } = useTranslation();
    const skip = !voucherContractId;
    const { data, isLoading, isError, isFetching, error, refetch } = useGetVoucherContractSummaryQuery({ voucherContractId: voucherContractId }, { skip });
    const summary = data ?? null;
    const vouchers = summary?.vouchers ?? [];
    const beneficiariesCount = summary?.beneficiaries ?? null;
    const renewalDate = summary?.renewalDate ?? null;
    const parsedError = useMemo(() => {
        if (!error)
            return null;
        if ('data' in error) {
            const errData = error.data;
            return errData?.message ?? t('benefits.contracted-benefits.errors.load-summary');
        }
        return t('benefits.contracted-benefits.errors.connection');
    }, [error, t]);
    return {
        summary,
        vouchers,
        beneficiariesCount,
        renewalDate,
        isLoading,
        isError,
        isFetching,
        isRefetching: isFetching && !isLoading,
        error: parsedError,
        refetch,
    };
}
